// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___2c2iN","header":"styles__header___C_83n","loading":"styles__loading___3G2mu","content":"styles__content___3H3BW","card":"styles__card___2zWRf"};